/* eslint-disable */

import React, { useEffect } from "react";
import { Script } from "gatsby";
import siteConfig from "@/variables";

export const NewRelicScript = () => {
  useEffect(() => {
    const {ACCOUNT_ID, TRUST_KEY, AGENT_ID, LICENSE_KEY} = siteConfig.NEW_RELIC;
    window.NREUM || (window.NREUM = {});
    window.NREUM.init = {
      distributed_tracing: { enabled: true },
      privacy: { cookies_enabled: false },
      ajax: { deny_list: ["bam.nr-data.net"] },
    };

    window.NREUM.loader_config = {
      accountID: ACCOUNT_ID,
      trustKey: TRUST_KEY,
      agentID: AGENT_ID,
      licenseKey: LICENSE_KEY,
      applicationID: AGENT_ID,
    };
    window.NREUM.info = {
      beacon: "bam.nr-data.net",
      errorBeacon: "bam.nr-data.net",
      licenseKey: LICENSE_KEY,
      applicationID: AGENT_ID,
      sa: 1,
    };
  }, []);

  return (<Script src="/newrelic.js"/>);
};
